/**
 * The ONE place browser navigation is performed.
 *
 * `window.location.href = url` and `window.location.assign(url)` are correct at
 * runtime and untestable under jsdom 26 (what jest-environment-jsdom 30 ships):
 * `window.location` is a non-configurable own accessor, `location.assign` is
 * read-only, and `location.href` has no configurable setter — so
 * `Object.defineProperty(window, "location", …)`, the pattern four hub suites
 * used, now throws "TypeError: Cannot redefine property: location". jsdom does
 * not plan to change that.
 *
 * Routing every full-page navigation through these two functions makes the
 * behaviour observable without touching `window.location` at all: a test does
 * `jest.mock("@west-tennessee-consulting/ui/lib/utils/navigate")` and asserts on the call.
 *
 * READS of `window.location` (hostname, pathname, search) are unaffected and
 * stay inline — jsdom still lets a test drive those with `history.replaceState`.
 *
 * This is for FULL-PAGE navigation only. Inside an app, prefer the framework
 * router (`next/navigation`); reach for these when the point is to leave the
 * SPA entirely — sign-out, an OAuth handoff.
 */

/** Full-page navigation by assigning `location.href`. */
export function navigateTo(url: string): void {
  window.location.href = url;
}

/**
 * Full-page navigation via `location.assign`. Same effect as `navigateTo`;
 * kept distinct so a call site that deliberately uses `assign` (and the test
 * that asserts it) stays honest about which API it means.
 */
export function navigateAssign(url: string): void {
  window.location.assign(url);
}
